import { IRoundingFormatOptions } from './number-formatter.type';

export const DEFAULT_CURRENCY_SYMBOL_POSITION = 'left';
export const DEFAULT_CURRENCY_CODE = 'USD';
export const DEFAULT_CURRENCY_SYMBOL = '$';

export const DEFAULT_DECIMAL_DIVIDER: string = '.';
export const DEFAULT_THOUSANDS_DIVIDER: string = ',';
export const DEFAULT_INPUT_THOUSANDS_DIVIDER: string = '';
export const DEFAULT_NUMBER_PRECISION: number = 2;
export const DEFAULT_NEGATIVES: string = '-1.1';
export const MAX_NUMBER_PRECISION: number = 12;
export const DEFAULT_DISPLAY_DECIMAL: string = '0.00';

export enum NegativeNumberType {
  Common = 'Common',
  CommonWithWhiteSpace = 'CommonWithWhiteSpace',
  Money = 'Money',
}

export const NEGATIVE_NUMBER_NEGATIVES_MAPPING: Record<
  NegativeNumberType,
  string
> = {
  [NegativeNumberType.Common]: '',
  [NegativeNumberType.CommonWithWhiteSpace]: ' ',
  [NegativeNumberType.Money]: '(1.1)',
};

export const DEFAULT_ROUNDING_FORMAT_OPTIONS: IRoundingFormatOptions = {
  currency: DEFAULT_CURRENCY_CODE,
  symbol: DEFAULT_CURRENCY_SYMBOL,
  symbolPositioning: DEFAULT_CURRENCY_SYMBOL_POSITION,
  thousandsSeparator: DEFAULT_THOUSANDS_DIVIDER,
  defaultFormatValue: DEFAULT_DISPLAY_DECIMAL,
  decimalSeparator: DEFAULT_DECIMAL_DIVIDER,
  negatives: NEGATIVE_NUMBER_NEGATIVES_MAPPING.Money,
  precision: DEFAULT_NUMBER_PRECISION,
  roundingMethodType: 'nearest',
  percentagePrecision: DEFAULT_NUMBER_PRECISION,
};

export interface IFormattingType {
  precision?: number;
  decimalSeparator?: string;
  thousandsSeparator?: string;
}

export const NUMERICAL_ORDER_AMOUNT: number = 3;
